/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Radio from "@mostrans/web-components/components/base/Radio";
import { Avatar, Box, Dialog, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSetState } from "react-use";
import { updateProfileCandidate } from "../../../../graphql/mutations";
import { uploadImageCandidate } from "../../../../shared/firebaseServices";
import {
  generateFileName,
  isImageFile,
  swalAlert,
  toastError,
  toastSuccess,
  toFormatDate,
} from "../../../../shared/helpers";
import { useSetRecoilState } from "recoil";
import { globalLoadingAtom } from "../../../../shared/globalStates";

export default function Profile({ open, setOpen, handleClose, data, setData }) {
  const client = useApolloClient();
  const [isEmpty, setIsEmpty] = useState(false);
  const [edit, setEdit] = useState(false);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [values, setValues] = useSetState({
    address: data?.address,
    birth_date: data?.birth_date,
    full_name: data?.full_name,
    birth_location: data?.birth_location,
    gender: data?.gender,
    link_photo: data?.link_photo,
    phone_number: data?.phone_number,
    short_name: data?.short_name,
  });

  const [address, setAddress] = useState({
    address: "",
    region: "",
    city: "",
    subdistrict: "",
    urbanvillage: "",
    postal: "",
    rt: "",
    rw: "",
  });

  useEffect(() => {
    setValues({
      ...values,
      address:
        address.address +
        ",RT " +
        address.rt +
        ",RW " +
        address.rw +
        "," +
        address.urbanvillage +
        "," +
        address.subdistrict +
        "," +
        address.city +
        "," +
        address.region +
        "," +
        address.postal,
    });
  }, [address]);

  useEffect(() => {
    setValues({
      address: data?.address,
      birth_date: data?.birth_date,
      full_name: data?.full_name,
      birth_location: data?.birth_location,
      gender: data?.gender,
      link_photo: data?.link_photo,
      phone_number: data?.phone_number,
      short_name: data?.short_name,
    });
    setAddress({
      address: data?.address?.split(",").at(0),
      rt: data?.address?.split(",").at(1)?.replace("RT ", ""),
      rw: data?.address?.split(",").at(2)?.replace("RW ", ""),
      urbanvillage: data?.address?.split(",").at(3),
      subdistrict: data?.address?.split(",").at(4),
      city: data?.address?.split(",").at(5),
      region: data?.address?.split(",").at(6),
      postal: data?.address?.split(",").at(7),
    });
  }, [data, open]);

  useEffect(() => {
    if (handleEdited()) return setEdit(false);
  }, [values]);

  const handleSubmit = async () => {
    if (
      !address.address ||
      !address.region ||
      !address.city ||
      !address.subdistrict ||
      !address.urbanvillage ||
      !address.postal ||
      !address.rt ||
      !address.rw ||
      !values.birth_date ||
      !values.full_name ||
      !values.birth_location ||
      !values.gender ||
      !values.link_photo ||
      !values.phone_number ||
      !values.short_name
    ) {
      setIsEmpty(true);
    } else {
      setLoading(true);
      const result = await updateProfileCandidate(client, values);
      if (result.status !== "000") {
        toastError(result.errMsg);
      } else {
        toastSuccess("Edit success");
        setOpen(false);
        setData(values);
      }
      setLoading(false);
    }
  };

  const handleEdited = () => {
    if (
      values.address !== data?.address ||
      values.birth_date !== data?.birth_date ||
      values.full_name !== data?.full_name ||
      values.birth_location !== data?.birth_location ||
      values.gender !== data?.gender ||
      values.link_photo !== data?.link_photo ||
      values.phone_number !== data?.phone_number ||
      values.short_name !== data?.short_name
    ) {
      setEdit(false);
    } else {
      setEdit(true);
    }
  };
  const handleUploadImage = async (event) => {
    const {
      target: { files },
    } = event;
    const isImage = isImageFile(files[0]);
    if (!isImage) return swalAlert({ text: "Format file salah!", title: "Error" });
    const cv_name = generateFileName("image-", files[0].name);
    const link_photo = await uploadImageCandidate(files[0], cv_name);
    setValues({ link_photo: link_photo });
  };

  
  return (
    <React.Fragment>
      <Button
        variant="text"
        color="primary"
        size="small"
        type="tertiary"
        onClick={() => {
          setOpen(true);
          handleEdited();
        }}
        startIcon={<span className="material-icons"> edit </span>}
        sx={{ fontSize: "14px" }}>
        Edit Profile
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <Box>
          <Box p={2}>
            <Typography variant="h4">BASIC INFORMATION</Typography>
          </Box>
          <Divider />
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xs={12} my={1}>
                <div className="profile-image">
                  <label>
                    <Input
                      id="image"
                      name="image"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleUploadImage}
                    />
                    <Avatar
                      className="img-avatar"
                      alt={values.full_name}
                      src={values.link_photo}
                      sx={{
                        margin: "auto",
                        height: "100px",
                        width: "100px",
                      }}
                    />
                    <div className="overlay text-black">
                      <span className="image_icon material-icons text-black">edit</span>
                      <span className="image_text">Edit photo</span>
                    </div>
                  </label>
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormGroup
                  label="Full Name"
                  errorMessage={"Full name cannot be empty!"}
                  isError={isEmpty && !values.full_name}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <Input
                    id="full_name"
                    value={values.full_name}
                    onChange={(e) => {
                      setValues({
                        full_name: e.target.value.toUpperCase(),
                      });
                      handleEdited();
                    }}
                    type="text"
                    placeholder="Nama Lengkap"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormGroup
                  label="Short Name"
                  errorMessage={"Short name cannot be empty!"}
                  isError={isEmpty && !values.short_name}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <Input
                    id="short_name"
                    value={values.short_name}
                    onChange={(e) => {
                      setValues({
                        short_name: e.target.value.toUpperCase(),
                      });
                      handleEdited();
                    }}
                    type="text"
                    placeholder="Enter Short Name"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  label="Gender"
                  errorMessage={"Gender cannot be empty!"}
                  isError={isEmpty && !values.gender}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <div className="d-inline-flex">
                    <label htmlFor="male" style={{ margin: "0 10px 0 0" }}>
                      <Radio
                        id="male"
                        value={values.gender}
                        checked={values.gender === "M"}
                        onChange={() => {
                          setValues({ gender: "M" });
                          handleEdited();
                        }}
                        name="gender"
                      />
                      Laki-Laki
                    </label>
                    <label htmlFor="female" style={{ margin: "0 10px 0 0" }}>
                      <Radio
                        id="female"
                        value={values.gender}
                        checked={values.gender === "F"}
                        onChange={() => {
                          setValues({ gender: "F" });
                          handleEdited();
                        }}
                        name="gender"
                      />
                      Perempuan
                    </label>
                  </div>
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  label="Phone Number"
                  errorMessage={"Phone number cannot be empty!"}
                  isError={isEmpty && !values.phone_number}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <Input
                    id="phone_number"
                    value={values.phone_number}
                    onChange={(e) => {
                      setValues({
                        phone_number: e.target.value.toUpperCase(),
                      });
                      handleEdited();
                    }}
                    type="text"
                    placeholder="Enter Phone Number"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  label="Birth Location"
                  errorMessage={"Birth location cannot be empty!"}
                  isError={isEmpty && !values.birth_location}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <Input
                    id="birth_location"
                    value={values.birth_location}
                    onChange={(e) => {
                      setValues({
                        birth_location: e.target.value.toUpperCase(),
                      });
                      handleEdited();
                    }}
                    type="text"
                    placeholder="Enter Birth Location"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  label="Birth date"
                  errorMessage={"Birth date cannot be empty!"}
                  isError={isEmpty && !values.birth_date}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <Input
                    id="birth_date"
                    value={toFormatDate(values.birth_date)}
                    onChange={(e) => {
                      setValues({
                        birth_date: e.target.value.toUpperCase(),
                      });
                      handleEdited();
                    }}
                    type="date"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormGroup
                  label="Address"
                  errorMessage={"Address cannot be empty!"}
                  isError={isEmpty && !address.address}
                  isRequired
                  showChildErrorSign
                  className="font-size-main">
                  <Input
                    id="address"
                    value={address.address}
                    onChange={(e) => {
                      setAddress({
                        ...address,
                        address: e.target.value.toUpperCase(),
                      });
                      handleEdited();
                    }}
                    type="text"
                    multiline
                    placeholder="Enter Address"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <FormGroup
                  className="input_region font-size-main"
                  label="Region"
                  errorMessage={"Region cannot be empty!"}
                  isError={isEmpty && !address.region}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="Region"
                    name="Region"
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        region: e.target.value.toUpperCase(),
                      })
                    }
                    value={address.region}
                    type="text"
                    maxLength={20}
                    placeholder="Ex: Jawa Barat"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <FormGroup
                  className="input_city font-size-main"
                  label="City"
                  errorMessage={"City cannot be empty!"}
                  isError={isEmpty && !address.city}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="city"
                    name="city"
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        city: e.target.value.toUpperCase(),
                      })
                    }
                    value={address.city}
                    type="text"
                    maxLength={20}
                    placeholder="Ex: Bekasi"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <FormGroup
                  className="input_subdistrict font-size-main"
                  label="Sub-district"
                  errorMessage={"Sub-district cannot be empty!"}
                  isError={isEmpty && !address.subdistrict}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="subdistrict"
                    name="subdistrict"
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        subdistrict: e.target.value.toUpperCase(),
                      })
                    }
                    value={address.subdistrict}
                    type="text"
                    maxLength={20}
                    placeholder="Ex: Cakung"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <FormGroup
                  className="input_urbanvillage font-size-main"
                  label="Urban village"
                  errorMessage={"Urban village cannot be empty!"}
                  isError={isEmpty && !address.urbanvillage}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="urbanvillage"
                    name="urbanvillage"
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        urbanvillage: e.target.value.toUpperCase(),
                      })
                    }
                    value={address.urbanvillage}
                    type="text"
                    maxLength={20}
                    placeholder="Ex: Cakung Barat"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
                <FormGroup
                  className="input_postalcode font-size-main"
                  label="Postal Code"
                  errorMessage={"Postal Code cannot be empty!"}
                  isError={isEmpty && !address.postal}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="Postal_Code"
                    name="Postal_Code"
                    value={!address.postal ? "" : address.postal}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        setAddress({
                          ...address,
                          postal: e.target.value,
                        });
                      }
                    }}
                    type="text"
                    maxLength={6}
                    placeholder="Ex: 19504"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={1.5} lg={1.5} md={1.5} sm={1.5} xs={3}>
                <FormGroup
                  className="input_rt font-size-main"
                  label="RT"
                  errorMessage={"RT cannot be empty!"}
                  isError={isEmpty && !address.rt}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="rt"
                    name="rt"
                    value={!address.rt ? "" : address.rt}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        setAddress({
                          ...address,
                          rt: e.target.value,
                        });
                      }
                    }}
                    type="text"
                    maxLength={3}
                    placeholder="RT"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={1.5} lg={1.5} md={1.5} sm={1.5} xs={3}>
                <FormGroup
                  className="input_rw font-size-main"
                  label="RW"
                  errorMessage={"RW cannot be empty!"}
                  isError={isEmpty && !address.rw}
                  isRequired
                  showChildErrorSign
                  style={{ padding: "10px 0" }}>
                  <Input
                    id="rw"
                    name="rw"
                    value={!address.rw ? "" : address.rw}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        setAddress({
                          ...address,
                          rw: e.target.value,
                        });
                      }
                    }}
                    type="text"
                    maxLength={3}
                    placeholder="RW"
                    style={{ textTransform: "uppercase" }}
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Box p={2} textAlign="end">
            <Button onClick={() => setOpen(false)} variant="outlined" color="danger">
              Cancel
            </Button>
            <Button disabled={edit} onClick={handleSubmit}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
